import * as Sentry from '@sentry/react';
import { Route } from 'react-router-dom';
import PasswordProtection from 'components/passwordProtection';
import { UserContext } from 'contexts';
import { MyProfileQuery } from '@/apollo/graphql';
import { useUser } from '@/hooks/useUser';

export type User = NonNullable<MyProfileQuery['me']>;

type Props = {
  component?: React.ComponentType<any>;
  [key: string]: any;
};

const PrivateRoute = ({ component, ...rest }: Props) => {
  const { user, loading } = useUser();

  if (user) {
    Sentry.getCurrentScope().setUser({
      id: user.id,
      username: user.name,
      email: user.email
    });
  }

  const Component = component || (() => null);

  return (
    <UserContext.Provider value={{ loading, me: user }}>
      <PasswordProtection>
        <Route {...rest} render={props => <Component {...props} />} />
      </PasswordProtection>
    </UserContext.Provider>
  );
};

export default PrivateRoute;
